<div class="message-body" i18n="Generated Images Message@@aiImageGeneratedImagesMessage">Here are your generated images</div>
<div class="photo-grid" *ngIf="message.content?.items | arrayOrDefault as items">
  <div class="tile" *ngFor="let it of items" [class.added]="isAdded(it)">
    <img [src]="it.thumbUrl || it.url || (it.b64 ? ('data:image/png;base64,' + it.b64) : null)" alt="" />
    <div class="overlay">
		<button class="ribbon-button p-2" (click)="add(it)" *ngIf="!isAdded(it)">
			<mat-icon inline>add</mat-icon>
			<ng-container i18n="Button Label@@aiImageSuggestionsAddButtonLabel">Add</ng-container>
		</button>
		<button class="ribbon-button p-2 active" disabled *ngIf="isAdded(it)">
			<mat-icon inline>check</mat-icon>
			<ng-container i18n="Button Label@@aiImageSuggestionsAddedButtonLabel">Added</ng-container>
		</button>
		<button class="ribbon-button p-2" (click)="openPreview(it)" aria-label="Preview image">
			<mat-icon inline>visibility</mat-icon>
		</button>
    </div>
  </div>
  <div *ngIf="items.length > 1" class="add-all-row">
	  <button class="ribbon-button p-2 add-all mt-3 mb-3" *ngIf="!isAllAdded(items)" (click)="addAll(items)">
		  <mat-icon inline>add</mat-icon>
		  <ng-container i18n="Button Label@@aiImageSuggestionsAddAllButtonLabel">Add all</ng-container>
	  </button>
	  <button class="ribbon-button p-2 add-all mt-3 mb-3 active" disabled *ngIf="isAllAdded(items)">
		  <mat-icon inline>check</mat-icon>
		  <ng-container i18n="Button Label@@aiImageSuggestionsAddedAllButtonLabel">Added all</ng-container>
	  </button>
  </div>
</div>
